import { defineStore } from 'pinia'
import { ref } from 'vue'
import { BaseStore } from './baseStore'

interface Bank {
  id?: string
  name: string
  code: string
  agency?: string
  account?: string
  organizationId?: string
  createdAt?: string
  updatedAt?: string
}

class BankStore extends BaseStore {
  constructor() {
    super('banks')
  }

  async fetchBanks() {
    return await this.fetchCollection<Bank>()
  }

  async addBank(bank: Bank) {
    return await this.addDocument<Bank>(bank)
  }

  async updateBank(id: string, bank: Partial<Bank>) {
    return await this.updateDocument<Bank>(id, bank)
  }

  async deleteBank(id: string) {
    return await this.deleteDocument(id)
  }
}

export const useBankStore = defineStore('bank', () => {
  const bankStore = new BankStore()
  const banks = ref<Bank[]>([])
  const loading = ref(false)

  const fetchBanks = async () => {
    loading.value = true
    try {
      banks.value = await bankStore.fetchBanks()
    } catch (error) {
      console.error('Erro ao buscar bancos:', error)
      throw error
    } finally {
      loading.value = false
    }
  }

  const addBank = async (bank: Bank) => {
    try {
      const newBank = await bankStore.addBank(bank)
      banks.value.push(newBank)
      return newBank
    } catch (error) {
      console.error('Erro ao adicionar banco:', error)
      throw error
    }
  }

  const updateBank = async (id: string, bank: Partial<Bank>) => {
    try {
      const updatedBank = await bankStore.updateBank(id, bank)
      const index = banks.value.findIndex(b => b.id === id)
      if (index !== -1) {
        banks.value[index] = { ...banks.value[index], ...updatedBank }
      }
      return updatedBank
    } catch (error) {
      console.error('Erro ao atualizar banco:', error)
      throw error
    }
  }

  const deleteBank = async (id: string) => {
    try {
      await bankStore.deleteBank(id)
      banks.value = banks.value.filter(b => b.id !== id)
    } catch (error) {
      console.error('Erro ao excluir banco:', error)
      throw error
    }
  }

  return {
    banks,
    loading,
    fetchBanks,
    addBank,
    updateBank,
    deleteBank
  }
})